import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  open(event) {
    event.preventDefault()
    if (this.element.classList.contains("open")) return

    this.element.classList.add("open")
    document.body.style.overflow = "hidden"
    this._boundKeydown = this._onKeydown.bind(this)
    document.addEventListener("keydown", this._boundKeydown)
  }

  close(event) {
    if (event) event.preventDefault()
    this.element.classList.remove("open")
    document.body.style.overflow = ""
    if (this._boundKeydown) {
      document.removeEventListener("keydown", this._boundKeydown)
      this._boundKeydown = null
    }
    const form = this.element.querySelector("form")
    if (form) form.reset()
    this.element.querySelectorAll(".form-error, .flash-alert").forEach(el => el.remove())
    this.element.querySelectorAll(".input-error").forEach(el => el.classList.remove("input-error"))
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  _onKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
